import React from "react";
import { Divider } from "@mui/material";

import "./time-line.scss";

function Timeline({ timelineData, showDivider = true, variant = "lg" }) {
  return (
    <div className="timeline">
      {timelineData?.map((item) => (
        <div key={item?.id} className="timeline-item">
          <div className={`timeline-dot ${variant === "lg" ? "timeline-dot-lg" : "timeline-dot-sm"}`} />
          <div className={`flex flex-col gap-05 ${variant === "lg" ? "timeline-content-lg" : "timeline-content-sm"}`}>
            <div className="flex flex-col gap-0125">
              <div className={`timeline-header flex items-center  ${item.icon ? "with-icon" : "without-icon"}`}>
                <div className={`timeline-title ${variant === "lg" ? "timeline-title-lg" : "timeline-title-sm"}`}>
                  {item.title} {item.subtext && <span className="timeline-title-subtext">{`(${item?.subtext})`}</span>}
                </div>
                {showDivider && <Divider flexItem className="timeline-divider" />}
                {(item.date || item.duration) && (
                  <div className="timeline-date">
                    {item.date && (
                      <span className={`${variant === "sm" ? "timeline-date-sm" : ""} mr-025 ml-075`}>{item.date}</span>
                    )}
                    {item.date && item.duration && <span className="timeline-date-divider"> • </span>}
                    {item.duration && (
                      <span className={`${variant === "sm" ? "timeline-duration-sm" : ""} ml-025`}>
                        {item.duration}
                      </span>
                    )}
                  </div>
                )}
                {item.icon && <div className="time-line-icon">{item.icon}</div>}
              </div>
              {item.company && <p className="timeline-company">{item.company}</p>}
            </div>
            {item.description && (
              <ul className="timeline-details">
                {item.description?.map((detail) => (
                  <li key={detail}>{detail}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Timeline;
